<template>
  <div class="staff">
    <div class="container" id="show">
      <h3>成为员工</h3>
      <div class="content">
         <div class="text" v-html="priceList">
<!--          <h5>客服文员</h5>
          <div class="group">
            <p class="demand">招聘要求：</p>
            <p class="txt">女，高中中专大专以上学历，年龄不限，经验不限，可接收应届生，护士优先，有跑腿快递经验的优先，有微商电商网络营销经验者优先，底薪3000元加提成。包住包吃。熟悉电脑操作，精通office。</p>
          </div>
          <div class="group">
            <p class="demand">岗位职责：</p>
            <p class="txt">1、日常电话的接听、记录，单据的录入。</p>
            <p class="txt"> 2、订单信息查询、跟进、处理。</p>
            <p class="txt"> 3、员工的维护，咨询的处理和意见反馈。</p>
            <p class="txt"> 4、客户的维护，客户咨询的处理和意见反馈。</p>
          </div>
          <h5>跑腿快递员</h5>
          <div class="group">
            <p class="demand">招聘要求：</p>
            <p class="txt">（温馨提示：申请该职位需要下载一线快递员APP，并在上面申请入职。）</p>
            <p class="txt">3000000名，男女不限，学历不限，年龄在95岁以下，经验不限，按单结算工资，周结，上班自由，可利用闲暇时间做工，优秀者月薪能达6000元以上。</p>
          </div> -->

        </div>
        <div class="fmInfo">
          <div class="left">
            <label for="">
              <span class="info">应聘职位：</span>
              <input type="text" v-model="info.position">
              <span class="fill">*</span>
            </label>
            <label for="">
              <span class="info">姓名：</span>
              <input type="text" v-model="info.name">
              <span class="fill">*</span>
            </label>
            <label for="">
              <span class="info">身份证号：</span>
              <input type="text" v-model="info.cardNo">
              <span class="fill">*</span>
            </label>
            <label for="">
              <span class="info">联系电话：</span>
              <input type="text" v-model="info.phone">
              <span class="fill">*</span>
            </label>
            <label for="">
              <span class="info">微信或QQ号：</span>
              <input type="text" v-model="info.wecharOrQq">
            </label>
            <label for="">
              <span class="info">学历：</span>
              <input type="text" v-model="info.degree">
            </label>
            <label for="">
              <span class="info">专业：</span>
              <input type="text" v-model="info.major">
            </label>
            <label for="">
              <span class="info">毕业学校：</span>
              <input type="text" v-model="info.graduationSite">
              <span class="fill">*</span>
            </label>
            <label for="">
              <span class="info">现在住址：</span>
              <input type="text" v-model="info.address">
              <span class="fill">*</span>
            </label>
          </div>
          <div class="right">
            <label for="">
              <span class="info">所获奖项：</span>
              <textarea name="" cols="30" rows="10" v-model="info.award"></textarea>
            </label>
            <label for="">
              <span class="info">工作经历：</span>
              <textarea name="" cols="30" rows="10" v-model="info.experience"></textarea>
            </label>
            <label for="">
              <span class="info">业余爱好、擅长：</span>
              <textarea name="" id="" cols="30" rows="10"></textarea>
            </label>
            <label for="file">
              <span class="info">近期照片：</span>
              <div class="avatar">
                <label for="photo">
                  <img :src="avatar" alt="">
                </label>
                <input type="file" id="photo" @change="changeImage($event)" accept="image/gif,image/jpeg,image/jpg,image/png">
              </div>
              <span class="fill">*</span>
            </label>
            <input type="file" id="file">
            <button @click="commit">提交</button>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import {idCard, mobiles} from '../../utils/phone'
import {reqFileUpload, reqPreparesStaff} from '../../api'
import {reqFullText} from '../../api'
export default {
  data() {
    return {
      priceList: '',
      info: {
        position: '', // 应聘职位
        name: '', // 姓名
        cardNo: '', // 身份证号
        phone: '', // 联系电话
        wecharOrQq: '', // 微信或QQ号
        degree: '', // 学历
        major: '', // 专业
        graduationSite: '', // 毕业学校
        address: '', // 现在住址
        award: '', // 所获奖项
        experience: '', // 工作经历
        photo: '' // 图片id
      },
      avatar: ''
    }
  },
  created() {
    reqFullText('102').then(res => {
      if(res.code == 200) {
        this.priceList = res.data.bussData.msgContent.replace(/\/errands/g,"https://www.yixian-express.com/errands")
      }
    })

},
  methods: {
    // 提交信息
    commit() {
      if(!this.info.position) {
        this.$message({
          message: '应聘职位不能为空',
          type: 'error'
        })
      } else if(!this.info.name) {
        this.$message({
          message: '姓名不能为空',
          type: 'error'
        })
      } else if(!this.info.cardNo) {
        this.$message({
          message: '身份证号不能为空',
          type: 'error'
        })
      } else if(!idCard(this.info.cardNo)) {
        this.$message({
          message: '身份证号不正确',
          type: 'error'
        })
      } else if(!this.info.phone) {
        this.$message({
          message: '手机号不能为空',
          type: 'error'
        })
      } else if(!mobiles(this.info.phone)) {
        this.$message({
          message: '手机号不正确',
          type: 'error'
        })
      } else if(!this.info.graduationSite) {
        this.$message({
          message: '毕业学校不能为空',
          type: 'error'
        })
      } else if(!this.info.address) {
        this.$message({
          message: '现在住址不能为空',
          type: 'error'
        })
      } else if(!this.info.photo) {
        this.$message({
          message: '请上传照片',
          type: 'error'
        })
      } else {
        reqPreparesStaff(this.info).then(res => {
          if(res.code === 200) {
            this.$message({
              message: '申请成功',
              type: 'success'
            })

            // let {position, name, cardNo, phone, wecharOrQq, degree, major, graduationSite, address, award, experience, photo} = this.info
            this.info.position = ''
            this.info.name = ''
            this.info.cardNo = ''
            this.info.phone = ''
            this.info.wecharOrQq = ''
            this.info.degree = ''
            this.info.major = ''
            this.info.graduationSite = ''
            this.info.address = ''
            this.info.award = ''
            this.info.experience = ''
            this.info.photo = ''
          }
        })
      }
    },
    // 上传图片
    changeImage (e) {
      let file = e.target.files[0]
      if (file) {
        if (e.srcElement.accept.includes(file.type)) {
          const formData = new FormData()
          formData.append('file', file)
          this.avatar = window.URL.createObjectURL(e.srcElement.files.item(0))
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          reqFileUpload(formData).then(res => {
            if(res.code == 200) {
              this.$message({
                message: res.desc,
                type: 'success'
              })
              this.info.photo = res.result
            }
          })
        } else {
          this.$message({
            message: '图片格式不正确',
            type: 'error'
          })
        }
      }
    },
  }
}
</script>

<style scoped lang="less" type="text/less">
.staff{
  margin-bottom: 53px;
  h3{
    padding:51px 0 41px;
    border-bottom: 1px solid #e1e1e1;
    font-size: 24px;
    font-weight: bold;
  }
  .content{
    .text{
      padding:30px 0;
      h5{
        margin-bottom: 19px;
        color:#2FA1DE;
        font-weight: 700;
        font-size: 16px;
      }
      .group{
        .demand{
          font-size: 16px;
          font-weight: 700;
          line-height: 30px;
          margin-bottom: 10px;
          font-family:Alibaba-PuHuiTi-M;
        }
        .txt{
          width: 724px;
          line-height: 30px;
          &:last-of-type{
            margin-bottom: 30px;
          }
        }
      }

    }
    .fmInfo{
      display: flex;
      padding:30px;
      background: #fafafa;
      .left{
        margin-right: 95px;
        label{
          display: flex;
          line-height: 40px;
          margin-bottom: 20px;
          .info{
            display: block;
            width: 95px;
            text-align: right;
          }
          input{
            width: 340px;
            height: 40px;
            border: 1px solid #e1e1e1;
            text-indent: 10px;
          }
          .fill{
            color: #FF0000;
            margin-left: 15px;
          }
        }
      }
      .right{
        label{
          display: flex;
          line-height: 40px;
          margin-bottom: 20px;
          .info{
            width: 115px;
            text-align: right;
          }
          textarea{
            width: 336px;
            height: 100px;
            resize: none;
            border:1px solid #e1e1e1;
            text-indent: 10px;
          }
          .fill{
            margin-left:15px;
            color:red;
          }
          .avatar{
            width: 180px;
            height: 180px;
            border:1px solid #e1e1e1;
            background: #fff;
            cursor: pointer;
            label{
              width: 100%;
              height: 100%;
              img{
                display: block;
                width: 100%;
                height: 100%;
                background: #eee;
              }
            }
            input[type='file']{
              display: none;
            }
          }
          .code{
            width: 128px;
          }
        }
        #file{
          display: none;
        }
        button{
          width: 200px;
          height: 48px;
          margin-top:10px;
          margin-left:115px;
          color:#fff;
          font-size: 18px;
          font-weight: bold;
          background: #61aee6;
          border:none;
          box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
          border-radius:24px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/Staff.vue